import { type SharedData } from "@/types";
import { usePage } from "@inertiajs/react";

export function usePlanFeatures() {
  const { auth } = usePage<SharedData>().props;
  const planFeatures: string[] = auth?.planFeatures || [];

  const hasFeature = (feature: string): boolean => {
    return planFeatures.includes(feature);
  };

  const hasAnyFeature = (features: string[]): boolean => {
    return features.some((feature) => planFeatures.includes(feature));
  };

  const hasAllFeatures = (features: string[]): boolean => {
    return features.every((feature) => planFeatures.includes(feature));
  };

  return {
    planFeatures,
    hasFeature,
    hasAnyFeature,
    hasAllFeatures,
  };
}
